export const SERVICES_MANAGER = 'Client Services Manager'

export const FINANCIAL_ADVISOR = 'Financial Advisor'

const IMG_PATH = 'images/dedicatedTeam/'

export const DEDICATED_TEAM_MEMBERS = [
  {
    name: 'Emily Green',
    title: 'Financial Advisor',
    imgPath: `${IMG_PATH}emily-green.png`
  },
  {
    name: 'SJ Abrams',
    title: 'Financial Advisor',
    imgPath: `${IMG_PATH}sj-abrams.png`
  },
  {
    name: 'Allison Kvikstad',
    title: 'Financial Advisor',
    imgPath: `${IMG_PATH}allison-kvikstad.png`
  },
  {
    name: 'Sydney Atkins',
    title: 'Financial Advisor',
    imgPath: `${IMG_PATH}sydney-atkins.png`
  },
  {
    name: 'Taylor Boyle',
    title: 'Financial Advisor',
    imgPath: `${IMG_PATH}taylor-boyle.png`
  },
  {
    name: 'Emily Stern',
    title: 'Client Services Manager',
    imgPath: `${IMG_PATH}emily-stern.png`
  },
  {
    name: 'MJ Vasquez',
    title: 'Client Services Manager',
    imgPath: `${IMG_PATH}mj-vasquez.png`
  },
  {
    name: 'Jennie Sanders',
    title: 'Director of Investments',
    imgPath: `${IMG_PATH}jennie-sanders.png`
  },
  {
    name: 'Rachel Chamberlain',
    title: 'Director of Private Wealth',
    imgPath: `${IMG_PATH}rachel-chamberlain.png`
  },
  {
    name: 'Linda Lee',
    title: 'Investments Associate',
    imgPath: `${IMG_PATH}linda-lee.png`
  }
]

export const DEFAULT_TEAM_MEMBER = {
  imgPath: null
}

const findMemberByName = name => DEDICATED_TEAM_MEMBERS.find(t => t.name === name)

export const getPhotoForMember = (name) => {
  const teamMember = findMemberByName(name)
  if (teamMember) {
    return teamMember.imgPath
  }
  return DEFAULT_TEAM_MEMBER.imgPath
}

export const getInitialsFromName = (name) => {
  const split = name.toUpperCase().split(' ')
  const [firstName] = split
  const lastName = split[split.length - 1]
  if (firstName.length > 0 && lastName.length > 0) {
    return `${firstName[0]}${lastName[0]}`
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/Client/dedicatedTeam.js